module.exports = __webpack_public_path__ + "img/bg-login-participant-thumb.682cddf3.jpg";